import { render, staticRenderFns } from "./Applicationsp.vue?vue&type=template&id=32e65db5&"
import script from "./Applicationsp.vue?vue&type=script&lang=js&"
export * from "./Applicationsp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports